import React, { Component } from "react"
import "./scss/contact.scss"

export default class Calender extends Component {
  loadScriptDynamically(src, bookalet, property) {
    let script = document.createElement("script")
    script.src = src
    script.setAttribute("data-bookalet", bookalet)
    script.setAttribute("data-property", property)
    document.querySelector(".contact-form").appendChild(script)
  }

  componentDidMount() {
    this.loadScriptDynamically(
      "https://widgets.bookalet.co.uk/publish.js",
      "1b8dd80b-49b5-429d-ac74-136f25e49ffc",
      "13541"
    )
  }
  render() {
    return (
      <div className="contact-form-wrap">
        <section className="contact-form"></section>
      </div>
    )
  }
}
